(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__mhCardSwatchesV1) return;
  window.__mhCardSwatchesV1 = true;
  const pending = new WeakMap();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('button[data-mh-card-swatch]');
    if (!swatch || swatch.disabled) return;
    const card = swatch.closest('.product-card-wrapper');
    const image = card?.querySelector('.card__media img');
    const rawUrl = swatch.dataset.mhImageUrl;
    if (!card || !image || !rawUrl) return;

    let imageUrl;
    try {
      imageUrl = new URL(rawUrl, window.location.href);
      if (imageUrl.protocol !== 'https:' && imageUrl.protocol !== 'http:') return;
    } catch {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const token = {};
    pending.set(card, token);
    card.setAttribute('aria-busy', 'true');
    const preview = new Image();
    const finish = () => {
      if (pending.get(card) !== token) return false;
      pending.delete(card);
      card.removeAttribute('aria-busy');
      return card.isConnected && swatch.isConnected && image.isConnected;
    };

    preview.onload = () => {
      if (!finish()) return;
      image.removeAttribute('srcset');
      image.src = imageUrl.href;
      image.alt = swatch.dataset.mhImageAlt || image.alt;
      card.classList.add('mh-swatch-preview');
      card.querySelectorAll('button[data-mh-card-swatch]').forEach((button) => {
        button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
      });
    };
    preview.onerror = () => { finish(); };
    preview.src = imageUrl.href;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
